module.exports = __webpack_public_path__ + "img/communityBj.aaf55018.png";